__turbopack_context__.v({
  "benefitItem": "SJnB0G_benefitItem",
  "benefitsSection": "SJnB0G_benefitsSection",
  "buttonWrapper": "SJnB0G_buttonWrapper",
  "card": "SJnB0G_card",
  "content": "SJnB0G_content",
  "disclaimer": "SJnB0G_disclaimer",
  "divider": "SJnB0G_divider",
  "lineItem": "SJnB0G_lineItem",
  "lineItemLabel": "SJnB0G_lineItemLabel",
  "lineItemPrice": "SJnB0G_lineItemPrice",
  "taxInfo": "SJnB0G_taxInfo",
  "totalContainer": "SJnB0G_totalContainer",
});
